import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { StudyState } from '../../../models';
import { PworkflowComponent } from '../index';
import { ServiceInterface } from 'services/service.interface';
import { GoogleAnalyticsEventsService } from 'services/google.analytics.events.service';
import { stateConstant } from '../../../../constants';
import { stringUtility } from '../../../../utils/stringUtility';
var EducationComponent = /** @class */ (function () {
    function EducationComponent(_services, _parent, googleAnalyticsEventsService) {
        this._services = _services;
        this._parent = _parent;
        this.googleAnalyticsEventsService = googleAnalyticsEventsService;
        this.formClass = "";
        this.errormsg = new Array();
        this.errdisplay = false;
        this.states = stateConstant;
        this.trackingName = "Education";
        this.stringUtil = new stringUtility();
    }
    EducationComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var state_1, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this._parent.campaignName) {
                            this.trackingName = this._parent.campaignName + " - Education";
                        }
                        if (this._parent.collegeDetails) {
                            state_1 = this.states.find(function (state) { return state.value == _this._parent.collegeDetails.state; });
                            if (!this._parent.model.study_state.find(function (statedata) { return statedata.name == state_1.name; })) {
                                this._parent.model.study_state.push(state_1);
                            }
                        }
                        this.settypeahead(this.states);
                        _a = this;
                        return [4 /*yield*/, this._services.getList('/levels')];
                    case 1:
                        _a.levels = _b.sent();
                        this.stringUtil.mergeStringContainFromArray(this.levels, 'certificate', 'Certificates');
                        return [2 /*return*/];
                }
            });
        });
    };
    EducationComponent.prototype.settypeahead = function (source) {
        var thisel = this;
        $("#study-state").typeahead({
            minLength: 0,
            delay: 100,
            autoSelect: true,
            items: 'all',
            source: source,
            displayText: function (item) { return item.name; },
            afterSelect: function (item) {
                var csitem = new StudyState();
                if (thisel._parent.model.study_state.length < 5) {
                    if (thisel._parent.model.study_state.findIndex(function (x) { return x.value.toLowerCase() == item.value.toLowerCase(); }) < 0) {
                        csitem.name = item.name;
                        csitem.value = item.value;
                        thisel._parent.model.study_state.push(csitem);
                    }
                }
                else {
                    alert("You cannot choose more than 5 states");
                }
                $("#study-state").val("");
            }
        });
    };
    EducationComponent.prototype.loadStudystate = function () {
        this._parent.model.study_state_value = " ";
        $("#study-state").typeahead('lookup');
        this._parent.model.study_state_value = "";
    };
    EducationComponent.prototype.deleteStudystate = function (val) {
        for (var index = 0; index < this._parent.model.study_state.length; index++) {
            if (this._parent.model.study_state[index]["value"].toLowerCase() == val.toLowerCase()) {
                this._parent.model.study_state.splice(index, 1);
            }
        }
    };
    EducationComponent.prototype.changeEducationgoal = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sel;
            return tslib_1.__generator(this, function (_a) {
                this._parent.model.education_goal = id;
                sel = "0";
                if (this._parent.model.education_goal != "") {
                    sel = this._parent.model.education_goal;
                }
                return [2 /*return*/];
            });
        });
    };
    EducationComponent.prototype.checkRadioButton = function (id) {
        if (this._parent.model.education_goal == id) {
            document.getElementById('mark-error').className = 'radio-choice mt-2 mb-0';
            return true;
        }
        else {
            return false;
        }
    };
    EducationComponent.prototype.clickSubmit = function (valid) {
        this.errormsg = [];
        if (valid) {
            if (this._parent.model.education_goal == "") {
                document.getElementById('mark-error').className = 'error-check mt-2 mb-0';
                // document. = "checkmark ng-invalid2"
                this.errdisplay = true;
                this.errormsg.push("Please enter education goal.");
            }
            else {
                this.educationsubmit();
            }
        }
        else {
            if (this._parent.model.education_goal == "") {
                document.getElementById('mark-error').className = 'error-check mt-2 mb-0';
                // document. = "checkmark ng-invalid2"
                this.errdisplay = true;
                this.errormsg.push("Please enter education goal.");
            }
            if (this._parent.model.study_state.length == 0) {
                this.errdisplay = true;
                this.errormsg.push("Please enter study state.");
            }
            this.formClass = "validate";
        }
    };
    EducationComponent.prototype.educationsubmit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this._parent.model.study_state.length > 0) {
                    this._parent.model.study_state_values = this._parent.model.study_state.map(function (a) { return a.value; }).join(',');
                    //this.googleAnalyticsEventsService.emitEvent(this.trackingName, this.trackingName, this.trackingName, 1);
                    this._parent.index++;
                }
                return [2 /*return*/];
            });
        });
    };
    return EducationComponent;
}());
export { EducationComponent };



// WEBPACK FOOTER //
// ./src/app/components/pworkflow/education/education.component.ts.pre-build-optimizer.js